var TabProductsModule = /** @class */ (function () {
    function TabProductsModule() {
    }
    return TabProductsModule;
}());
export { TabProductsModule };
